export default {
    baseStyle: {
        container: {
            position: 'relative',
            spacing: {base: 6, lg: '40px'},
            height: {base: '100%'},
            maxW: {base: '458px'},
        },
        centerContent: {
            margin: {base: '0 auto'},
            width: {base: '100%'}
        },
        cta: {
            width: {base: '100%'},
            minH: {base: '48px'}
        },
        addAddressCta: {
            maxW: {lg: '343px'},
            fontSize: 'md'
        },
        addressWrapper: {
            flexDirection: {base: 'column'},
            justifyContent: {base: 'space-between'},
            flex: {base: '1'}
        },
        noAddressTitle: {
            fontSize: {base: 'md'},
            lineHeight: {base: '20px'},
            fontWeight: '500',
            marginTop: {base: 8, lg: 0},
            marginBottom: {base: 2},
        },
        noAddressSubTitle: {
            fontSize: {base: 'sm'},
            lineHeight: {base: '18px'},
            marginBottom: {base: 6, lg: 10},
        }
    },
    headingAddressBook: {
        container: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: {base: 'center', lg: 'start'},
            fontSize: {base: '20px', lg: '24px'},
            lineHeight: {base: '24px', lg: '30px'},
            fontWeight: {base: 'bold'},
            textTransform: 'uppercase',
            position: 'relative',
        },
        backButton: {
            position: 'absolute',
            left: '0',
            m: '0'
        }
    },
    formStyle: {
        container: {
            display: {base: 'flex'},
            flexDirection: {base: 'column'},
            justifyContent: {base: 'space-between'},
            flex: '1'
        },
        submitCta: {
            marginTop: {base: '40px'}
        },
        deleteCtaContainer: {
            display: {base: 'flex'},
            justifyContent: {base: 'center'},
            marginTop: {base: 8}
        },
        errorContainer: {
            marginTop: {base: 4, lg: 0},
            marginBottom: {lg: 8}
        }
    },
    addressCard: {
        container: {
            border: '1px solid',
            borderColor: {base: 'grey.300'},
            marginBottom: {base: 8},
            padding: '16px 0 16px 16px',
        },
        wrapper: {
            position: {base: 'relative'},
            paddingRight: {base: 7}
        },
        preferred: {
            fontSize: {base: '12px'},
            lineHeight: {base: '15px'},
            textTransform: 'uppercase',
            fontWeight: '500',
            lineHeight: '16px',
        },
        title: {
            fontSize: {base: 'md'},
            right: {base: 0},
            top: {base: 0},
            cursor: 'pointer'
        },
        editDeleteText: {
            fontSize: {base: '14px'}
        }
    },
    addressModal: {
        container: {
            maxWidth: {base: '100%', lg: '458px'},
            width: {base: '100%'},
            height: {base: '100%'},
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            padding: {base: 6, lg: 10}
        },
        heading: {
            fontSize: {base: '16px'},
            lineHeight: {base: '16px'},
            fontWeight: '700',
            textTransform: 'uppercase',
        },
        fieldHeading: {
            fontSize: {base: '14px'},
            lineHeight: {base: '14px'},
            fontWeight: '700',
            textTransform: 'uppercase',
        },
        optionalFieldHeading: {
            fontSize: {base: '14px'},
            lineHeight: {base: '14px'},
            lineHeight: {base: '16px', lg: '16px'},
            fontWeight: '500',
        },
        formWrapper: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            flex: 1
        },
        submitCta: {
            marginTop: {base: 8}
        },
        deleteCtaContainer: {
            display: {base: 'flex'},
            justifyContent: {base: 'center'},
            marginTop: {base: 8}
        },
        errorContainer: {
            marginTop: {base: 4, lg: 0},
            marginBottom: {lg: 8}
        },
        suggestionItem: {
            textStyle: 'bodySmRegular',
            px: 2,
            py: 3,
            minH: '48px',
            borderBottom: '1px solid',
            borderColor: 'webTheme.strokeTertiary',
            _last: {borderBottom: 0},
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            wordBreak: 'break-word',
            _hover: {bg: 'webTheme.fieldHover'},
            _focus: {bg: 'webTheme.fieldHover', outline: 'none'}
        },
        suggestionGroupHeader: {
            justifyContent: 'space-between',
            px: 2,
            py: 3,
            borderBottom: '1px solid',
            borderColor: 'webTheme.strokeTertiary',
            _last: {borderBottom: '1px solid', borderColor: 'webTheme.strokeTertiary'}
        },
        suggestionGroupLabel: {
            textStyle: 'bodyXsRegular',
            color: 'webTypo.textSecondary'
        },
        suggestionGroupAddress: {
            textStyle: 'bodySmRegular'
        }
    },  
    parts: []
}